const Style = (theme) => ({
  add__btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '100%',
    borderRadius: '1000px',
    background: 'rgba(105, 33, 196, 0.2)',
    color: '#6921C4',
    width: '143px',
    '&:hover': {
      background: 'rgba(105, 33, 196, 0.2)',
    },
    [theme.breakpoints.between(960, 1130)]: {
      width: '106px',
      fontSize: '12px',
      '& svg': {
        height: ' 17px',
        width: ' 17px',
        padding: ' 1px',
        marginBottom: ' 2px',
      },
    },
  },

  customer__fields: {
    position: 'absolute',
    top: '3.7rem',
    width: '30rem',
    borderRadius: '15px',
    background: '#fff',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.04)',
  },
});
export default Style;
